import React, { useEffect, useState} from "react";
import firebaseDb from "../firebase";
import Loading from "../images/loading2.gif";
import {  ref, child, get} from "firebase/database";
import Bounce from 'react-reveal/Bounce';

const Blog = () => {

    
   

        const [contactObjects, setContactObjects] = useState({}) 
        const dbRef = ref(firebaseDb);
        const [isLoading, setLoading] = useState(true)
   
        useEffect(() => {
         get(child(dbRef,'intereses')).then((snapshot) => {
             if (snapshot.exists()) {
            
              
               setContactObjects({
                 ...snapshot.val()
             })
   
             setLoading(false) 
            
           
              //console.log(snapshot.val());
             } else {
               setContactObjects({})
               console.log("No data available");
             }
           }).catch((error) => {
             console.error(error);
           });
   }, []);
   
        return (

<Bounce right>
            <div>

                <section className="blogs">

                    <h1 className="heading"> <span>meus </span> interesses</h1>

                    <div className="box-container">

                        <div className="box">
                            <div className="image">
                     {isLoading 
                          ? 
                          <div className="image">
                          
                            <img src={Loading} alt="img"/>
                          </div>
                          : (
                                
                            <div className="image">
                            {Object.keys(contactObjects).map((key) => {
                                return (
                                      <img src={contactObjects[key].interes1} alt="img"/>
                                    );
                                  })}
                           
                            </div>
                            )
                          }
                            </div>
                            <div className="content">
                                <div className="icons">
                                    <h3>Desporto</h3>
                                    <a>  <i className="fas fa-futbol fa-2x" ></i></a>
                                </div>
                                <h3>Mente saudável</h3>
                                <p>Gosto de praticar esportes porque melhora o condicionamento físico e a resistência física.</p>

                            </div>
                        </div>

                        <div className="box">
                            <div className="image">
                            {isLoading 
                          ? 
                          <div className="image">
                          
                            <img src={Loading} alt="img"/>
                          </div>
                          : (
                                
                            <div className="image">
                            {Object.keys(contactObjects).map((key) => {
                                return (
                                      <img src={contactObjects[key].interes2} alt="img"/>
                                    );
                                  })}
                           
                            </div>
                            )
                          }
                            </div>
                            <div className="content">
                                <div className="icons">
                                    <h3>Música</h3>
                                    <a>  <i className="fas fa-music fa-2x" ></i></a>
                                </div>
                                <h3>Relaxar</h3>
                                <p>Ouvir música relaxante às vezes é o melhor aliviador de estresse que eu posso colocar minhas mãos.</p>

                            </div>
                        </div>

                        <div className="box">
                            <div className="image">
                            {isLoading 
                          ? 
                          <div className="image">
                          
                            <img src={Loading} alt="img"/>
                          </div>
                          : (
                                
                            <div className="image">
                            {Object.keys(contactObjects).map((key) => {
                                return (
                                      <img src={contactObjects[key].interes3} alt="img"/>
                                    );
                                  })}
                           
                            </div>
                            )
                          }
                            </div>
                            <div className="content">
                                <div className="icons">
                                    <h3>Ensino</h3>
                                    <a>  <i className="fa fa-graduation-cap fa-2x" ></i></a>
                                </div>
                                <h3>Compartilhando conhecimento</h3>
                                <p> Além de ser um entusiasta da tecnologia, também adoro ensinar às pessoas o que sei..</p>

                            </div>
                        </div>

                        <div className="box">
                            <div className="image">
                            {isLoading 
                          ? 
                          <div className="image">
                          
                            <img src={Loading} alt="img"/>
                          </div>
                          : (
                                
                            <div className="image">
                            {Object.keys(contactObjects).map((key) => {
                                return (
                                      <img src={contactObjects[key].interes4} alt="img"/>
                                    );
                                  })}
                           
                            </div>
                            )
                          }
                            </div>
                            <div className="content">
                                <div className="icons">
                                    <h3>Jogos</h3>
                                    <a>  <i className="fas fa-gamepad fa-2x" ></i></a>
                                </div>
                                <h3>Melhorar as habilidades</h3>
                                <p>Eu realmente gosto de desafiar meus reflexos e habilidades motoras enquanto competi em videogames.</p>

                            </div>
                        </div>

                        <div className="box">
                            <div className="image">
                            {isLoading 
                          ? 
                          <div className="image">
                          
                            <img src={Loading} alt="img"/>
                          </div>
                          : (
                                
                            <div className="image">
                            {Object.keys(contactObjects).map((key) => {
                                return (
                                      <img src={contactObjects[key].interes5} alt="img"/>
                                    );
                                  })}
                           
                            </div>
                            )
                          }
                            </div>
                            <div className="content">
                                <div className="icons">
                                    <h3>Tecnologia</h3>
                                    <a>  <i className="fas fa-microchip fa-2x" ></i></a>
                                </div>
                                <h3>Evolução</h3>
                                <p>Sou apaixonado por tecnologia porque me permite reunir habilidades, conhecimento e novas ferramentas</p>

                            </div>
                        </div>

                        <div className="box">
                            <div className="image">
                            {isLoading 
                          ? 
                          <div className="image">
                          
                            <img src={Loading} alt="img"/>
                          </div>
                          : (
                                
                            <div className="image">
                            {Object.keys(contactObjects).map((key) => {
                                return (
                                      <img src={contactObjects[key].interes6} alt="img"/>
                                    );
                                  })}
                           
                            </div>
                            )
                          }
                            </div>
                            <div className="content">
                                <div className="icons">
                                    <h3>Aprender</h3>
                                    <a>  <i className="fas fa-lightbulb fa-2x" ></i></a>
                                </div>
                                <h3>Adquirir conhecimento</h3>
                                <p>Estou sempre em busca de novos conhecimentos, habilidades, que me permitam crescer cada vez mais a cada dia</p>

                            </div>
                        </div>

                    </div>

                </section>

            </div>
</Bounce>
        )
    }


export default Blog
